import React from 'react'
import { DialogBody } from '../../../legacy-design-system/modal'
import { css } from '@emotion/css'

export function Form(props) {
  return (
    <DialogBody>
      <form
        noValidate
        className={css`
          padding: 0 5px;
        `}
      >
        {props.children}
      </form>
    </DialogBody>
  )
}
